import { ReactNode } from 'react';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';
import { hmsTheme } from './theme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={hmsTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
